import { useContext, useMemo } from "react";

import { AuthContext } from "../../context/AuthProvider";
import {
  BOARD_PERMISSION,
  NON_MEMBER_PERMISSIONS,
} from "../../constants/permission";
import { BOARD_CODE, USER_TYPE } from "../../constants";

export const checkRoleAndPermissions = (
  role,
  board,
  permission,
  nonPermissions = {},
  isAdmin = false
) => {
  if (isAdmin) return true;

  switch (role) {
    case USER_TYPE.NONE:
      let result = nonPermissions[permission] || false;

      switch (board?.boardCode) {
        case BOARD_CODE.BABY_CHEER:
        case BOARD_CODE.CARE_CHEER:
        case BOARD_CODE.BABY_MEMORIAL:
        case BOARD_CODE.QUESTION:
        case BOARD_CODE.CONTACT:
          result = result && board.options.useAnonymous;
          break;
        default:
          break;
      }
      return result;
    default:
      return board?.permissions && role
        ? board.permissions[role][permission]
        : false;
  }
};

export const getPermissionMessage = (permission) => {
  switch (permission) {
    case BOARD_PERMISSION.WRITE:
      return "쓰기 권한이 없습니다.\n관리자에게 문의하여 주시기 바랍니다.";
    case BOARD_PERMISSION.READ:
      return "조회 권한이 없습니다.\n관리자에게 문의하여 주시기 바랍니다.";
    default:
      return "접근 권한이 없습니다.\n관리자에게 문의하여 주시기 바랍니다.";
  }
};

export const CheckRoleAndPermissionDisplay = (props) => {
  const { children, showMessage, board, permission, boardCode } = props;

  const { roleCode, isAdmin } = useContext(AuthContext);

  const nonPermissions = useMemo(
    () => NON_MEMBER_PERMISSIONS[boardCode],
    [boardCode]
  );

  const isDisplay = useMemo(
    () =>
      board?.permissions
        ? checkRoleAndPermissions(
            roleCode,
            board,
            permission,
            nonPermissions,
            isAdmin
          )
        : false,

    [board, roleCode, permission, nonPermissions, isAdmin]
  );

  if (isDisplay || isAdmin) return children;

  return showMessage ? (
    <div className="py-8">
      <p className="text-center text-lg text-gray-dark pt-10 whitespace-pre-wrap">
        {getPermissionMessage(permission)}
      </p>
    </div>
  ) : null;
};
